<div class="search-textbox">
  <span class="k-icon k-i-search"></span>
  <input kendoTextBox [placeholder]="placeholder" [(ngModel)]="value" [ngClass]="classList" (ngModelChange)="onModelChange($event)" />
  <span *ngIf="value" class="k-icon k-i-close" (click)="clearValue()"></span>
</div>
